import axios from "axios";
import {baseUrlBigQuery, xApiKeyBigQuery} from "../../config/apiConfig/apiConfig";

class BqBridgingService {
    private axios = axios.create({
        baseURL: baseUrlBigQuery,
    });

    public async storeData(inputData?: any) {
        try {
            return await this.axios.post<any>('/amartavinfast/evtaxi-driver',
                inputData, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": xApiKeyBigQuery
                    }
                });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async storeDataVehicle(inputData?: any) {
        try {
            return await this.axios.post<any>('/amartavinfast/evtaxi-vehicle',
                inputData, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": xApiKeyBigQuery
                    }
                });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async storeDataGreenTravel(inputData?: any) {
        try {
            return await this.axios.post<any>('/amartavinfast/green-travel',
                inputData, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": xApiKeyBigQuery
                    }
                });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }

    public async storeDataGsmPlatform(inputData?: any) {
        try {
            return await this.axios.post<any>('/amartavinfast/gsm-platform',
                inputData, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": xApiKeyBigQuery
                    }
                });
        } catch (e: any) {
            if (e.response?.data?.messages) {
                throw new Error(e.response.data.messages);
            }
            throw new Error(e.response?.data?.error?.message || "Terjadi kesalahan pada server");
        }
    }

    public async storeDataGsmDriver(inputData?: any) {
        try {
            return await this.axios.post<any>('/amartavinfast/gsm-driver',
                inputData, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": xApiKeyBigQuery
                    }
                });
        } catch (e: any) {
            if (e.response?.data?.messages) {
                throw new Error(e.response.data.messages);
            }
            throw new Error(e.response?.data?.error?.message || "Terjadi kesalahan pada server");
        }
    }
}

export const bqBridgingService = new BqBridgingService();
